import { reportUsage } from '@ms/yammer-data/dist/telemetry';
import { useProductNameShort } from '@ms/yammer-hooks/dist/rebranding';
import Block from '@ms/yammer-web-core-ui/dist/components/Block';
import Flex, { FlexItem } from '@ms/yammer-web-core-ui/dist/components/Flex';
import Image from '@ms/yammer-web-core-ui/dist/components/Image';
import InternalLink from '@ms/yammer-web-core-ui/dist/components/InternalLink';
import SemanticHeading from '@ms/yammer-web-core-ui/dist/components/SemanticHeading';
import { feedPageUrl } from '@ms/yammer-web-support/dist/urls';
import React, { FC } from 'react';

const vivaEngageLogoPath = require('@ms/yammer-assets/dist/images/VivaEngageLogo.svg');

const AppBrandLink: FC = () => {
  const appName = useProductNameShort();
  const onLogoClick = () => {
    reportUsage({ eventName: 'viva_engage_icon_clicked' });
  };

  return (
    <InternalLink onClick={onLogoClick} to={feedPageUrl} unstyled={true} display="inline-block">
      <Flex columnGap={2} display="inline-flex" alignItems="center">
        <FlexItem minWidth={24}>
          <Image source={vivaEngageLogoPath} height={24} width={24} description="" block={true} />
        </FlexItem>
        <SemanticHeading level={1}>
          <Block textPreset="subtitle1">{appName}</Block>
        </SemanticHeading>
      </Flex>
    </InternalLink>
  );
};

export default AppBrandLink;
